(function () {
    var parser = {};

    /*******************
     Default translation strings
     (will be used ONLY if no app config is provided on library init)
     *******************/
    var default_translations = {
        "days": "d",
        "hours": "h",
        "minutes": "m",
        "seconds": "s",
        "all_day": "All Day",
        "full_pain_duration": "for #v1",
        "dashboard_new": "NEW"
    };

    /*******************
     Core functions
     *******************/

    var isObject = function (value) {
        return value !== null && typeof value === 'object'
    };

    var isString = function (value) {
        return typeof value === 'string';
    };

    var isDefined = function (value) {
        return typeof value !== 'undefined';
    };

    var isUndefined = function (value) {
        return typeof value === 'undefined';
    };

    var urlEncode = function (str) {
        str = (str + '').toString();

        return encodeURIComponent(str)
            .replace(/!/g, '%21')
            .replace(/'/g, '%27')
            .replace(/\(/g, '%28')
            .replace(/\)/g, '%29')
            .replace(/\*/g, '%2A')
            .replace(/%20/g, '+');
    };

    var urlDecode = function (str) {
        return decodeURIComponent((str + '')
            .replace(/%(?![\da-f]{2})/gi, function () {
                return '%25';
            })
            .replace(/\+/g, '%20'));
    };

    var isUrlEncoded = function (str) {
        return typeof str === "string" && urlDecode(str) !== str;
    };

    /*
        Checking whether or not element is empty
        Examples:
        - isEmpty([]) = true
        - isEmpty({}) = true
        - isEmpty(null) = true
        - isEmpty(undefined) = true
        - isEmpty({'aFunc' : function () { alert('test'); } }) = false
     */
    var isEmpty = function (mixedVar) {
        var undef, key, i, len;
        var emptyValues = [undef, null, false, 0, '', '0'];

        for (i = 0, len = emptyValues.length; i < len; i++) {
            if (mixedVar === emptyValues[i]) {
                return true;
            }
        }

        if (typeof mixedVar === 'object') {
            if (mixedVar instanceof Date) {
                return false;
            }
            for (key in mixedVar) {
                return false;
            }
            return true;
        }

        return false;
    };

    /*
        Checking whether or not element is in array
     */
    var inArray = function (val, arr) {
        return (arr.indexOf(val) > -1);
    };

    /*
        Translating all items in an object to new array of items
     */
    var mapObjectElementToArrayElement = function (elems, callback) {
        var value,
            i = 0,
            isArray = Array.isArray(elems),
            ret = [];

        // Go through the array, translating each of the items to their new values
        if (!isArray) {
            for (i in elems) {
                value = callback(elems[i], i);

                if (value !== null) {
                    ret.push(value);
                }
            }

            // Flatten any nested arrays
            var arr = [];
            return arr.concat.apply([], ret);
        }
    };

    /*
        Converting Object to Array
     */
    var object2Array = function (obj) {
        if (!isObject(obj)) {
            return obj;
        }

        return mapObjectElementToArrayElement(obj, function (v) {
            return v;
        });
    };

    /*
        Rounding float values with the given precision. If no precision is provided - than value will be rounded to the nearest Integer
        Examples:
        - roundWithPrecision(4.84775, 2) = 4.85
        - roundWithPrecision(5.74) = 6
     */
    var roundWithPrecision = function (value, precision) {
        var multiplier = Math.pow(10, precision || 0);
        return Math.round(value * multiplier) / multiplier;
    };

    /*
        Translation function - uses translations passed on library init
        Valid 'type' parameters are:
        - 'content' - for those strings that have the following format 'content_Name'
        - 'replace' - for those strings that contain #v1, #v2, etc. parts which need to be replaced with the provided numbers/strings/etc.
     */
    var translate = function (input, type) {
        if (isUndefined(type)) {
            type = null;
        }

        var orig_input = input;

        if (type === 'content') {
            if (!isUrlEncoded(input)) {
                input = urlEncode(input);
            }
            input = 'content_' + input;
        }
        if (type === 'replace') {
            var index = 1;
            if (isUndefined(parser.translations) || isUndefined(parser.translations[input])) {
                return "";
            }
            var output = parser.translations[input];
            for (var i = 2; i < arguments.length; i++) {
                output = output.replace('#v' + index, arguments[i]);
                index++;
            }
            return output;
        }

        if (isUndefined(parser.translations) || isUndefined(parser.translations[input])) {
            if (type === 'content') {
                return orig_input;
            }
            return ""; // Return empty string
        }

        return parser.translations[input];
    };

    /*
        Executing provided function once for each array / object element
     */
    var forEach = function (obj, callback) {
        var value,
            i = 0,
            length = obj.length,
            isArray = Array.isArray(obj);

        if (isArray) {
            for (; i < length; i++) {
                if (obj.hasOwnProperty(i)) {
                    value = callback.call(obj[i], i, obj[i]);

                    if (value === false) {
                        break;
                    }
                }
            }
        } else {
            for (i in obj) {
                if (obj.hasOwnProperty(i)) {
                    value = callback.call(obj[i], i, obj[i]);

                    if (value === false) {
                        break;
                    }
                }
            }
        }

        return obj;
    };

    /*
        Checking whether or not provided daterange object is valid (= contains all 4 dates)
     */
    var isDaterangeObjectValid = function (daterangeObject) {
        if (!isDefined(daterangeObject)) {
            return false;
        } else {
            return isDefined(daterangeObject.start_date) && isDefined(daterangeObject.end_date)
                && isDefined(daterangeObject.compare_to_start_date) && isDefined(daterangeObject.compare_to_end_date);
        }
    };

    /*************************
     Auxiliary functions
     *************************/

    var defaultDateFormat = 'YYYY-MM-DD';
    var insightsDataDateFormat = 'MM-DD-YYYY';
    var recordsDateFormat = 'DD-MM-YYYY';
    var recordSections = ["location", "character", "symptom", "aggravating_factor_displayed", "alleviating_factor_displayed", "ineffective_factor_displayed", "environment"];

    /*
        Translating seconds to days, hours, minutes, seconds. If minutes are greater than 10, seconds are set to 0.
        Examples:
        - secondsToDHMS(123456) = {days: 1, hours: 10, minutes: 17, seconds: 0}
        - secondsToDHMS(45001) = {days: 0, hours: 12, minutes: 30, seconds: 0}
        - secondsToDHMS(378) = {days: 0, hours: 0, minutes: 6, seconds: 18}
     */
    var secondsToDHMS = function (seconds) {
        var d, h, m, s;
        s = ((seconds % 86400) % 3600) % 60;
        m = Math.floor(((seconds % 86400) % 3600) / 60);
        if (m > 10) {
            s = 0;
        }
        h = Math.floor((seconds % 86400) / 3600);
        d = Math.floor(seconds / 86400);
        if (d === 1 && h === 0) {
            d = 0;
            h = 24;
        }
        return {days: d, hours: h, minutes: m, seconds: s};
    };

    /*
        Calculate and fill record timing based on time offset
     */
    var getFinalTiming = function (record) {
        if (!record.final_timing) {
            record.final_timing =
                parseInt(record.timing) +
                parseInt(record.time_offset) +
                new Date(
                    parseInt(record.timing) + parseInt(record.time_offset)
                ).getTimezoneOffset() *
                60000;
        }
        return record.final_timing;
    };

    /*
        Calculate and cache records date formats without using momentJS,
        as momentJS is too slow for large amount of records in native app
     */
    var fillFormattedDates = function (record) {
        if (!record.defaultDateFormat) {
            var d = new Date(getFinalTiming(record)),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;

            record.defaultDateFormat = [year, month, day].join('-');
            record.insightsDataDateFormat = [month, day, year].join('-');
            record.recordsDateFormat = [day, month, year].join('-');
        }
    };

    /*
        Determining whether or not a record belongs to the current date period
     */
    var isRecordInDateRange = function (record, daterangeObject) {

        var startDate = daterangeObject.start_date;
        var endDate = daterangeObject.end_date;
        fillFormattedDates(record);
        var thisDate = record.defaultDateFormat;

        return (thisDate >= startDate && thisDate <= endDate);
    };

    /*
        Determining whether or not a record belongs to the previous ('compare to') date period
     */
    var isRecordInPrevDateRange = function (record, daterangeObject) {

        var startDate = daterangeObject.compare_to_start_date;
        var endDate = daterangeObject.compare_to_end_date;
        fillFormattedDates(record);
        var thisDate = record.defaultDateFormat;

        return (thisDate >= startDate && thisDate <= endDate);
    };

    /*
        Translating pain duration value into the corresponding duration id
     */
    var parseDuration = function (duration) {
        duration = parseInt(duration / 60);
        if (duration > 0 && duration < 60) {
            return 'less_hour'; // Increment value
        } else if (duration >= 60 && duration < 180) {
            return 'less_three'; // Increment value
        } else if (duration >= 180 && duration < 360) {
            return 'less_six'; // Increment value
        } else if (duration >= 360 && duration < 720) {
            return 'less_twelve'; // Increment value
        } else if (duration >= 720 && duration < 1440) {
            return 'less_twenty_four'; // Increment value
        } else if (duration === 1440) {
            return 'twenty_four'; // Increment value
        } else if (duration > 1440) {
            return 'more_twenty_four'; // Increment value
        }
    };

    /*
        Incrementing appropriate pain duration number according to the provided duration
     */
    var fillDuration = function (duration, durationUnit, painDurations) {
        if (!duration || typeof duration === 'undefined') {
            return;
        }
        duration = parseInt(duration / 60);
        if (duration >= 0 && duration < 60) {
            painDurations.less_hour++; // Increment value
        } else if (duration >= 60 && duration < 180) {
            painDurations.less_three++; // Increment value
        } else if (duration >= 180 && duration < 360) {
            painDurations.less_six++; // Increment value
        } else if (duration >= 360 && duration < 720) {
            painDurations.less_twelve++; // Increment value
        } else if (duration >= 720 && duration < 1440) {
            painDurations.less_twenty_four++; // Increment value
        } else if (duration === 1440) {
            painDurations.twenty_four++; // Increment value
        } else if (duration > 1440) {
            painDurations.more_twenty_four++; // Increment value
        }
    };

    /*
        Filling out representative bars info for pain type and duration sections
     */
    var fillTypeOrDurationItems = function (record, section, prev) {
        if (section.id === 'pain_duration') {
            var nameEncoded = parseDuration(record[section.id]);
        } else if (section.id === 'pain_type') {
            var nameEncoded = record[section.id];
        }
        if (isUndefined(section.items[nameEncoded]) && prev === true) {
            return;
        }
        if (isUndefined(section.items[nameEncoded])) { // If not defined than add in the items array
            section.items[nameEncoded] = {
                name_encoded: nameEncoded,
                name: urlDecode(nameEncoded),
                prev_num_records: 0,
                num_records: 0
            };
        }

        if (prev) { // This means its a prev record
            section.items[nameEncoded].prev_num_records++;
        } else { // Current record
            section.items[nameEncoded].num_records++;
        }
    };

    /*
        Filling out representative bars info for other insights sections
     */
    var fillSectionItems = function (record, section, prev) {
        if (!record[section.id]) {
            return;
        }

        forEach(record[section.id], function (i, v) {
            var nameEncoded = v;
            if (isUndefined(section.items[nameEncoded]) && prev === true) {
                return;
            }
            if (isUndefined(section.items[nameEncoded])) { // If not defined than add in the items array
                section.items[nameEncoded] = {
                    name_encoded: nameEncoded,
                    name: urlDecode(nameEncoded),
                    prev_num_records: 0,
                    num_records: 0
                };
            } else { // Increment
                if (prev) { // This means its a prev record
                    section.items[nameEncoded].prev_num_records++;
                } else { // Current record
                    section.items[nameEncoded].num_records++;
                }
            }
        });
    };

    /*
        Filling out bar chart information for each section item:
        arrays with current or previous records (depending on isPrev flag state), including records severities
     */
    var fillSectionItemInformation = function (records, insightsSections, isPrev) {
        var sectionItemsMap = {};
        forEach(records, function (i, record) {
            record.tmpNames = {};
            forEach(insightsSections, function (j, section) {
                if (record[section.id]) {
                    forEach(record[section.id], function (k, v) {
                        var name = v;
                        if (!record.tmpNames[section.id]) {
                            record.tmpNames[section.id] = [];
                        }
                        record.tmpNames[section.id].push({name: name});
                    });
                }
            });
        });
        forEach(insightsSections, function (j, section) {
            sectionItemsMap[section.id] = {};
            if (section.items) {
                forEach(section.items, function (k, item) {
                    sectionItemsMap[section.id][item.name_encoded] = item;
                });
            }
        });

        forEach(records, function (i, record) {
            fillFormattedDates(record);
            var ymd = record.defaultDateFormat;
            var timing = parseInt(record.final_timing); // Converting time into int format
            if (isNaN(timing)) return true; // If time in NAN return

            forEach(insightsSections, function (j, section) {
                if (section.id !== 'pain_type' && section.id !== 'pain_duration' &&
                    isDefined(section.items) && section.items.length > 0) {
                    var sectionId = section.id;
                    if (isEmpty(record[sectionId])) {
                        return;
                    }
                    forEach(record.tmpNames[sectionId], function (i, v) {
                        var name = v.name;

                        var item = sectionItemsMap[sectionId][name];
                        if (!item) {
                            return;
                        }
                        if (isUndefined(item.bar_chart_data)) {
                            item.bar_chart_data = {};
                        }
                        var numRecordsKey = isPrev ? 'prev_num_records' : 'num_records';
                        var recordsInfoKey = isPrev ? 'prev_records_info' : 'records_info';
                        var numUsersKey = isPrev ? 'prev_num_users' : 'num_users';
                        var userIdsInfoKey = isPrev ? 'prev_user_ids' : 'user_ids';
                        var recordsPerUserInfoKey = isPrev ? 'prev_records_per_user_info' : 'records_per_user_info';

                        if (isUndefined(item.bar_chart_data[userIdsInfoKey])) {
                            item.bar_chart_data[userIdsInfoKey] = [];
                        }
                        if (isUndefined(item.bar_chart_data[recordsPerUserInfoKey])) {
                            item.bar_chart_data[recordsPerUserInfoKey] = {};
                        }


                        if (!item.bar_chart_data[userIdsInfoKey][record.patient_id]) {
                            item.bar_chart_data[userIdsInfoKey][record.patient_id] = [record.severity];
                            item.bar_chart_data[recordsPerUserInfoKey][record.patient_id] = [record.severity];
                        } else {
                            item.bar_chart_data[recordsPerUserInfoKey][record.patient_id].push(record.severity);
                        }
                        item.bar_chart_data[numUsersKey] = (item.bar_chart_data[userIdsInfoKey]) ? Object.keys(item.bar_chart_data[userIdsInfoKey]).length : 0;

                        if (isUndefined(item.bar_chart_data[numRecordsKey])) { // If first record with item - create necessary objects
                            item.bar_chart_data[numRecordsKey] = 1;
                            item.bar_chart_data[recordsInfoKey] = {};
                            item.bar_chart_data[recordsInfoKey][ymd] = [{
                                severity: record.severity,
                                timing: record.final_timing
                            }];
                        } else {
                            item.bar_chart_data[numRecordsKey]++;
                            // If no records on ymd date - then create and fill an array, otherwise - add to the existing one
                            if (isUndefined(item.bar_chart_data[recordsInfoKey][ymd])) {
                                item.bar_chart_data[recordsInfoKey][ymd] = [{
                                    severity: record.severity,
                                    timing: record.final_timing
                                }];
                            } else {
                                item.bar_chart_data[recordsInfoKey][ymd].push({
                                    severity: record.severity,
                                    timing: record.final_timing
                                });
                            }
                        }
                    });
                }
            });
            record.tmpNames = null;
        });

    };

    /*
        Calculating change in records number and average severity for each section item
     */
    var fillChangeData = function (itemFrequenciesBarData) {
        itemFrequenciesBarData.has_change_data = (isDefined(itemFrequenciesBarData.prev_records_info));
        itemFrequenciesBarData.num_records_change = (isDefined(itemFrequenciesBarData.prev_records_info)) ? itemFrequenciesBarData.num_records - itemFrequenciesBarData.prev_num_records : 0;
        itemFrequenciesBarData.avg_severity_change = (isDefined(itemFrequenciesBarData.prev_records_info)) ? roundWithPrecision(itemFrequenciesBarData.avg_severity - itemFrequenciesBarData.prev_avg_severity, 1) : 0;
        itemFrequenciesBarData.num_users_change = (isDefined(itemFrequenciesBarData.prev_records_info)) ? roundWithPrecision(itemFrequenciesBarData.num_users - itemFrequenciesBarData.prev_num_users, 1) : 0;
        itemFrequenciesBarData.avg_num_records_change = (isDefined(itemFrequenciesBarData.prev_records_info) && isDefined(itemFrequenciesBarData.avg_num_records)) ? roundWithPrecision(itemFrequenciesBarData.avg_num_records - itemFrequenciesBarData.prev_avg_num_records) : 0;
    };

    /*
        Parsing alleviating / ineffective factors
     */
    var parseAlleviatingFactor = function (record) {
        // If is defined alleviating factor in record object and not empty
        if (isDefined(record.alleviating_factor) && record.alleviating_factor) {
            record.ineffective_factor_displayed = []; // Define ineffective factor array
            record.ineffective_factor_for_calculation = []; // Define ineffective factor array
            record.alleviating_factor_displayed = []; // Define alleviating factor array
            record.alleviating_factor_for_calculation = []; // Define alleviating factor array
            // Loop on the object
            forEach(record.alleviating_factor, function (i, v) {
                if (isString(v)) {
                    var tmp = v.split(":");
                    var name = tmp[0];

                    var isEffective = isDefined(tmp[1]) ? parseInt(tmp[1]) : 0;

                    if (isEffective) { // If record is effective record then add to alleviating factor array
                        record.alleviating_factor_for_calculation.push(name);
                        record.alleviating_factor_displayed.push(name);
                    } else { // Add to ineffective factor array
                        record.ineffective_factor_for_calculation.push(name);
                        record.ineffective_factor_displayed.push(name);
                    }
                } else if (isObject(v)) {
                    var factor = v.value;
                    var fullFactor = v.value + (v.dosage ? " - " + v.dosage + " " + v.dosage_units_translated : "");
                    if (v.effectiveness === 1) {
                        record.alleviating_factor_for_calculation.push(factor);
                        record.alleviating_factor_displayed.push(fullFactor);
                    } else {
                        record.ineffective_factor_for_calculation.push(factor);
                        record.ineffective_factor_displayed.push(fullFactor);
                    }
                }
            });
        }
        return record;
    };

    /*
        Parsing aggravating factors
     */
    var parseAggravatingFactor = function (record) {
        if (isDefined(record.aggravating_factor) && record.aggravating_factor) {
            record.aggravating_factor_for_calculation = [];
            record.aggravating_factor_displayed = [];
            // Loop on the object
            forEach(record.aggravating_factor, function (i, v) {
                if (isObject(v)) {
                    var factor = v.value;
                    var fullFactor = v.value + (v.dosage ? " - " + v.dosage + " " + v.dosage_units_translated : "");
                    record.aggravating_factor_for_calculation.push(factor);
                    record.aggravating_factor_displayed.push(fullFactor);
                } else {
                    record.aggravating_factor_for_calculation.push(v);
                    record.aggravating_factor_displayed.push(v);
                }
            });
        }
        return record;
    };

    /*
        Checking whether or not a record belongs to the user which is in current participants set
     */
    var checkStatus = function (participants, uid, status) {
        var check = false;
        forEach(participants, function (i, participant) {
            if (participant.uid == uid) {
                check = (participant.status === status);
            }
        });
        return check;
    };

    /*
        Calculating average severity for the pain records added on the specific date
     */
    var setAverageSeverityPerDate = function (finalDailyReflectionRecords, finalPainRecords, daterangeObject) {
        var painRecordsMap = finalPainRecords.map(function (record) {
            var prDate = new Date(getFinalTiming(record));
            if (daterangeObject.tz) {
                var offset = new parser.momentJS.tz.zone(daterangeObject.tz).utcOffset(
                    (parseInt(record.timing) + parseInt(record.time_offset))) * 60000;
                prDate = parseInt(record.timing) + parseInt(record.time_offset) + offset;
                var final = new parser.momentJS(prDate).format("ddd MMM DD YYYY");
                return {
                    date: final,
                    severity: record.severity,
                    patient_id: record.patient_id
                };
            }
            return {
                date: prDate.toDateString(),
                severity: record.severity,
                patient_id: record.patient_id
            };
        });
        var dateSeverityMap = {};
        forEach(painRecordsMap, function (i, dateRec) {
            if (!dateSeverityMap[dateRec.date]) {
                dateSeverityMap[dateRec.date] = [];
            }
            dateSeverityMap[dateRec.date].push(dateRec);
        });
        forEach(finalDailyReflectionRecords, function (i, record) {
            var count = 0;
            var totalSeverity = 0;
            var drDate = new Date(parseInt(record.timing));
            var dateString = drDate.toDateString();
            if (daterangeObject.tz) {
                var offset = new parser.momentJS.tz.zone(daterangeObject.tz).utcOffset(
                    (parseInt(record.timing) + parseInt(record.time_offset))) * 60000;
                drDate = parseInt(record.timing) + parseInt(record.time_offset) + offset;
                dateString = new parser.momentJS(drDate).format("ddd MMM DD YYYY");
            }

            if (dateSeverityMap[dateString]) {
                forEach(dateSeverityMap[dateString], function (j, rec) {
                    if (record.patient_id === rec.patient_id) {
                        totalSeverity += rec.severity;
                        count++;
                    }
                });
                if (count !== 0) {
                    record.average_severity = parseFloat(totalSeverity / count);
                } else {
                    record.average_severity = -1;
                }
            } else {
                record.average_severity = -1;
            }
        });

    };

    /*
        Calculating average severity for the pain records containing specific section item
     */
    var getAverageSeverityForRecordsContainingItem = function (arr, calculateBy, isPrev) {
        // If array is empty return
        if (isEmpty(arr)) {
            return;
        }

        var averageSeverityKey = isPrev ? 'prev_avg_severity' : 'avg_severity';
        var averageSeverityRoundedKey = isPrev ? 'prev_avg_severity_rounded' : 'avg_severity_rounded';
        var numRecordsKey = isPrev ? 'prev_num_records' : 'num_records';
        var recordsInfoKey = isPrev ? 'prev_records_info' : 'records_info';
        var recordsPerUserInfoKey = isPrev ? 'prev_records_per_user_info' : 'records_per_user_info';
        var avgNumRecordsKey = isPrev ? 'prev_avg_num_records' : 'avg_num_records';

        // Looping on array
        for (var ind in arr) {

            var v = arr[ind].bar_chart_data;
            v[averageSeverityKey] = 0; // Default average severity will be 0
            // If total number of records are zero than return true
            if (isEmpty(v[numRecordsKey])) {
                continue; // Continue;
            }

            if (calculateBy !== 'participants') {
                var totalSeverity = 0; // Default total severity
                // Looping on records info
                forEach(v[recordsInfoKey], function (j, info) {
                    for (var s in info) {
                        totalSeverity += parseFloat(info[s].severity); // Increment total severity records
                    }
                });

                v[averageSeverityKey] = roundWithPrecision(totalSeverity / v[numRecordsKey], 1, true); // Calculating average severity
                v[averageSeverityRoundedKey] = Math.round(v[averageSeverityKey]); // Rounding average severity to the nearest integer
            } else {
                var numUsers = 0;
                var totalRecords = 0;
                var totalAvgSeverityPerUser = 0;
                // looping on records info
                forEach(v[recordsPerUserInfoKey], function (j, info) {
                    var tmpSeverity = 0;
                    var numRecords = 0;
                    for (var s in info) {
                        tmpSeverity += parseFloat(info[s]); // Increment total severity records
                        numRecords++;
                    }
                    totalAvgSeverityPerUser += tmpSeverity / numRecords;
                    totalRecords += numRecords;
                    numUsers++;
                });

                v[avgNumRecordsKey] = roundWithPrecision(totalRecords / numUsers); // Calculating average number of records per user
                v[averageSeverityKey] = roundWithPrecision(totalAvgSeverityPerUser / numUsers, 1, true); // Calculating average severity
                v[averageSeverityRoundedKey] = Math.round(v[averageSeverityKey]); // Rounding average severity to the nearest integer
            }
        }
    };

    /*
        Getting number of the selected participants depending on the active selected mode (whether or not Follow up list is active)
     */
    var getNumberOfSelected = function (participantsSet, followUpListMode) {
        var numberOfSelected = 0;
        var participants = [];

        if (followUpListMode) {
            forEach(participantsSet, function (i, participant) {
                if (participant.isFollowed) {
                    participants.push(participant);
                }
            });
        } else {
            participants = participantsSet;
        }

        forEach(participants, function (i, participant) {
            if (participant.isSelected) {
                numberOfSelected++;
            }
        });
        return numberOfSelected;
    };

    /*
        Calculating all Insights data needed for Severity and Function charts
     */
    var calculateChartsData = function (insightsData, calculateBy, daterangeObject) {
        // Defining arrays
        var finalSeverityData = [],
            finalFunctionData = [],
            finalInsightsData = [];
        // Defining record and reflection object
        var painRecord = {},
            reflectionData = {};

        var tdate = '';
        var painRecordUsers = [];
        var dailyReflectionUsers = [];
        // Defining variables for change values
        var totalSeverityValue = 0,
            totalFunctionValue = 0,
            totalPainRecords = 0,
            totalFunctionRecords = 0,
            finalAverageSeverity = 0,
            finalAverageFunction = 0;

        // Loop on the insights data for filling array with severity and function data
        forEach(insightsData, function (userId, data) {
            // Looping on pain records
            forEach(data.PainRecord.records, function (index, record) {

                fillFormattedDates(record);
                tdate = record.insightsDataDateFormat;
                if (!isEmpty(tdate)) {
                    if (isEmpty(painRecord[tdate])) {
                        painRecord[tdate] = {};
                    }
                    if (isEmpty(painRecord[tdate][userId])) {
                        painRecord[tdate][userId] = {};
                    }
                    if (!inArray(userId, painRecordUsers)) {
                        painRecordUsers.push(userId);
                    }
                    // Adding records on the basis of date
                    painRecord[tdate][userId][index] = {
                        'date': tdate,
                        'severity': record.severity,
                        'record_type': record.pain_record_type
                    };
                }

            });
            // Looping on daily reflection records
            forEach(data.DailyReflection.records, function (index, record) {
                fillFormattedDates(record);
                tdate = record.insightsDataDateFormat;
                if (!isEmpty(tdate)) {
                    if (isEmpty(reflectionData[tdate])) {
                        reflectionData[tdate] = {};
                    }
                    if (isEmpty(reflectionData[tdate][userId])) {
                        reflectionData[tdate][userId] = {};
                    }
                    if (!inArray(userId, dailyReflectionUsers)) {
                        dailyReflectionUsers.push(userId);
                    }
                    // Adding records on the basis of date
                    reflectionData[tdate][userId][index] = {
                        'date': tdate,
                        'severity': record.severity,
                        'record_type': record.pain_record_type
                    };
                }
            });
        });
        // Looping on pain records for summing up pain records on the same date
        forEach(painRecord, function (sdate, tData) {
            var averageSeverityValue = 0;
            var finalValue = 0;
            var counter = 0;
            var averageUserValue = 0;
            var painUsers = 0;
            var dailyHigh = 0;
            var dailyLow = 0;
            forEach(tData, function (userId, pData) {
                var dataCounter = 0;
                var userSeverity = 0;
                var incrementUser = true;
                forEach(pData, function (ind, data) {
                    if (isUndefined(data.severity)) {
                        incrementUser = false;
                        return;
                    }
                    averageSeverityValue += parseInt(data.severity);
                    totalSeverityValue += parseInt(data.severity);
                    userSeverity += parseInt(data.severity);
                    totalPainRecords++; // Calculating total pain records
                    counter++;
                    if (dataCounter === 0) {
                        dailyHigh = parseInt(data.severity);
                        dailyLow = parseInt(data.severity);
                    } else {
                        dailyHigh = (parseInt(data.severity) > dailyHigh) ? parseInt(data.severity) : dailyHigh;
                        dailyLow = (parseInt(data.severity) < dailyLow) ? parseInt(data.severity) : dailyLow;
                    }
                    dataCounter++;

                });
                if (calculateBy !== "records" && dataCounter > 0) {
                    averageUserValue += userSeverity / dataCounter;
                }
                if (incrementUser) {
                    painUsers++;
                }

            });
            var sdateObj = sdate.split("-");
            var timestamp = new Date(sdateObj[2], sdateObj[0] - 1, sdateObj[1]).getTime();
            if (daterangeObject.tz) {
                var rfcFormat = sdateObj[2] + '-' + sdateObj[0] + '-' + sdateObj[1];
                var moment = new parser.momentJS.tz(rfcFormat, daterangeObject.tz);
                timestamp = moment.valueOf();
            }

            if (counter > 0 && calculateBy === "records") {
                finalValue = averageSeverityValue / counter;
            } else if (painUsers > 0 && calculateBy !== "records") {
                finalValue = averageUserValue / painUsers;
            }
            if (!isNaN(finalValue)) {
                finalAverageSeverity += finalValue;
                finalSeverityData.push({
                    date: timestamp,
                    score: finalValue,
                    high: dailyHigh,
                    low: dailyLow,
                    records: counter,
                    users: painUsers
                });
            }
        });
        // Looping on reflection records for summing up reflection records on the same date
        forEach(reflectionData, function (sdate, tData) {
            var averageSeverityValue = 0;
            var finalValue = 0;
            var counter = 0;
            var averageUserValue = 0;
            var painUsers = 0;
            forEach(tData, function (userId, pData) {
                var dataCounter = 0;
                var userSeverity = 0;
                var incrementUser = true;
                forEach(pData, function (ind, data) {
                    if (isUndefined(data.severity)) {
                        incrementUser = false;
                        return;
                    }
                    averageSeverityValue += parseInt(data.severity);
                    totalFunctionValue += parseInt(data.severity);
                    userSeverity += parseInt(data.severity);
                    totalFunctionRecords++; // Calculating total function records
                    counter++;
                    dataCounter++;
                });
                if (calculateBy !== "records" && dataCounter > 0) {
                    averageUserValue += userSeverity / dataCounter;
                }
                if (incrementUser) {
                    painUsers++;
                }
            });
            var sdateObj = sdate.split("-");
            var timestamp = new Date(sdateObj[2], sdateObj[0] - 1, sdateObj[1]).getTime();

            if (daterangeObject.tz) {
                var rfcFormat = sdateObj[2] + '-' + sdateObj[0] + '-' + sdateObj[1];
                var moment = new parser.momentJS.tz(rfcFormat, daterangeObject.tz);
                timestamp = moment.valueOf();
            }

            if (counter > 0 && calculateBy === "records") {
                finalValue = averageSeverityValue / counter;
            } else if (painUsers > 0 && calculateBy !== "records") {
                finalValue = averageUserValue / painUsers;
            }
            if (!isNaN(finalValue)) {
                finalAverageFunction += finalValue;
                finalFunctionData.push({date: timestamp, score: finalValue, records: counter, users: painUsers});
            }
        });
        // Calculating average Severity
        var averageSeverity = 0;
        if (finalSeverityData.length > 0) {
            averageSeverity = finalAverageSeverity / finalSeverityData.length;
        }
        // Calculating average Function
        var averageFunction = 0;
        if (finalFunctionData.length > 0) {
            averageFunction = finalAverageFunction / finalFunctionData.length;
        }
        // Filling array with averageSeverity, averageFunction, totalPainRecords, totalFunctionRecords
        finalInsightsData.push({
            'averageSeverity': averageSeverity,
            'averageFunction': averageFunction,
            'totalPainRecords': totalPainRecords,
            'totalFunctionRecords': totalFunctionRecords
        });

        // Sorting array on the basis of dates (asc - from the earliest to the latest)
        finalSeverityData.sort(
            parser.thenByJS('date')
        );
        finalFunctionData.sort(
            parser.thenByJS('date')
        );

        return {
            'finalSeverityData': finalSeverityData,
            'finalFunctionData': finalFunctionData,
            'insightsData': finalInsightsData
        };
    };

    /*
        Calculating average severities, total number of records, participants with activity and change values
     */
    var getSeverityAndFunctionChartsData = function (filteredRecords, prevFilteredRecords, calculateBy, daterangeObject, overlaySettings, calendarRecords, calendarDateRange) {

        /*
         Process records that belong to the selected date range and to the previous daterange for calculating change values
         */
        var records = calculateChartsData(filteredRecords, calculateBy, daterangeObject);
        var previousRecords = calculateChartsData(prevFilteredRecords, calculateBy, daterangeObject);


        var allChartsSummary = records;
        var calendarsData = monthWithEvents(calendarDateRange ? calendarRecords : filteredRecords, allChartsSummary, overlaySettings, calendarDateRange || daterangeObject);
        var finalSeverityData = records.finalSeverityData; // Severity data
        var finalFunctionData = records.finalFunctionData; // Function data

        /*
            Define average severity and function
        */
        var averageSeverity = !isUndefined(records.insightsData[0].averageSeverity) ? records.insightsData[0].averageSeverity : 0;
        var averageFunction = !isUndefined(records.insightsData[0].averageFunction) ? records.insightsData[0].averageFunction : 0;

        /*
            Get total number of pain records and daily reflections
        */
        var totalPainRecords = !isUndefined(records.insightsData[0].totalPainRecords) ? records.insightsData[0].totalPainRecords : 0;
        var totalDailyReflections = !isUndefined(records.insightsData[0].totalFunctionRecords) ? records.insightsData[0].totalFunctionRecords : 0;

        /*
            Calculating Severity and Function change values
        */
        var averageSeverityChange = 0;
        if (!isUndefined(previousRecords.insightsData[0].averageSeverity) && previousRecords.insightsData[0].averageSeverity !== 0) {
            averageSeverityChange = (roundWithPrecision(averageSeverity, 1) - roundWithPrecision(previousRecords.insightsData[0].averageSeverity, 1));
        }
        var averageFunctionChange = 0;
        if (!isUndefined(previousRecords.insightsData[0].averageFunction) && previousRecords.insightsData[0].averageFunction !== 0) {
            averageFunctionChange = (roundWithPrecision(averageFunction, 1) - roundWithPrecision(previousRecords.insightsData[0].averageFunction, 1));
        }

        /*
            Calculate change in number of daily reflections and pain records
        */
        var dailyReflectionChange = 0;
        if (!isUndefined(previousRecords.insightsData[0].totalFunctionRecords) && previousRecords.insightsData[0].totalFunctionRecords !== 0) {
            dailyReflectionChange = (totalDailyReflections - previousRecords.insightsData[0].totalFunctionRecords);
        }
        var painRecordChange = 0;
        if (!isUndefined(previousRecords.insightsData[0].totalPainRecords) && previousRecords.insightsData[0].totalPainRecords !== 0) {
            painRecordChange = (totalPainRecords - previousRecords.insightsData[0].totalPainRecords);
        }

        /*
            Count number of the participants in current period which have at least one pain record
            or one daily reflection - means that they have tracking activity in this period of time
        */
        var curNumberOfParticipantsWithActivity = 0;
        forEach(filteredRecords, function (i, object) {
            var userHasRecords = false;
            forEach(object, function (i, objectElem) {
                if (objectElem.records && objectElem.records.length > 0) {
                    userHasRecords = true;
                    return false;
                }
            });
            if (userHasRecords) {
                curNumberOfParticipantsWithActivity++;
            }
        });

        /*
            Count number of the participants in previous period which have at least one pain record
            or one daily reflection - means that they had tracking activity in previous period of time
        */
        var prevNumberOfParticipantsWithActivity = 0;
        forEach(prevFilteredRecords, function (i, object) {
            var userHasRecords = false;
            forEach(object, function (i, objectElem) {
                if (objectElem.records && objectElem.records.length > 0) {
                    userHasRecords = true;
                }
            });
            if (userHasRecords) {
                prevNumberOfParticipantsWithActivity++;
            }
        });

        return {
            averageSeverity: roundWithPrecision(averageSeverity, 1),
            averageSeverityChange: roundWithPrecision(averageSeverityChange, 1),
            averageFunction: roundWithPrecision(averageFunction, 1),
            averageFunctionChange: roundWithPrecision(averageFunctionChange, 1),
            painRecordChange: painRecordChange,
            dailyReflectionChange: dailyReflectionChange,
            participantsWithActivity: curNumberOfParticipantsWithActivity,
            participantsWithActivityChange: curNumberOfParticipantsWithActivity - prevNumberOfParticipantsWithActivity, // Change value for the number of participants with tracking activity
            severityChartData: finalSeverityData,
            functionChartData: finalFunctionData,
            calendarsData: calendarsData
        }
    };

    /*
        Generate array of months for date range.
     */

    var calendarMonth = function (daterangeObject) {
        var calendar = {};
        var start = parser.momentJS(daterangeObject.end_date).startOf('month').add(1, 'month'),
            end = parser.momentJS(daterangeObject.start_date).startOf('month'),
            diff = roundWithPrecision(parser.momentJS.duration(start.diff(end)).asMonths(), 0);
        var startYear = parser.momentJS(daterangeObject.start_date).year(),
            startMonth = parser.momentJS(daterangeObject.start_date).month(),
            endYear = parser.momentJS(daterangeObject.end_date).year(),
            endMonth = parser.momentJS(daterangeObject.end_date).month();
        var monthNum = 0;
        do {
            var str = startYear.toString();
            calendar[str.concat('-', startMonth)] = {year: startYear, month: startMonth, events: []};
            ++monthNum;
            ++startMonth;
            if (startMonth === 12) {
                startMonth = 0;
                ++startYear;
            }
        } while (monthNum < diff);
        return calendar;
    };

    /*
        Get all average severity and function for each day.
     */
    var monthWithEvents = function (filteredRecords, records, overlaySettings, daterangeObject) {
        var allMonths = calendarMonth(daterangeObject);
        var painEvents = {};
        forEach(filteredRecords, function (userId, data) {
            // Looping on pain records
            forEach(data.PainRecord.records, function (index, record) {
                var time = new Date(record.final_timing);
                fillFormattedDates(record);
                var date = time.setHours(0, 0, 0, 0);
                var dates = record.defaultDateFormat;
                var overlays = getOverlaysFormRecord(record, overlaySettings);
                if (!isDefined(painEvents[dates])) {
                    painEvents[dates] = (Object.assign({date: date, severity: record.severity, function: null, num: 1},
                        overlays));
                } else {
                    painEvents[dates].severity = painEvents[dates].severity + record.severity;
                    painEvents[dates].num += 1;
                    forEach(overlays, function (i, val) {
                        if (val) {
                            painEvents[dates][i] = true;
                        }
                    });
                }
            });
            forEach(data.DailyReflection.records, function (index, record) {
                var time = new Date(record.final_timing);
                fillFormattedDates(record);
                var date = time.setHours(0, 0, 0, 0);
                var dates = record.defaultDateFormat;
                var overlays = getOverlaysFormRecord(record, overlaySettings);
                if (!isDefined(painEvents[dates])) {
                    painEvents[dates] = (Object.assign({
                        date: date,
                        function: record.severity,
                        severity: null
                    }, overlays));
                } else {
                    painEvents[dates].function = record.severity;
                    forEach(overlays, function (i, val) {
                        if (val) {
                            painEvents[dates][i] = true;
                        }
                    });
                }
            });
        });

        return mergeEvents(painEvents, allMonths);
    };

    /*
        Merge severity and overlays and include it to months array
     */
    var mergeEvents = function (painEvents, allMonths) {
        for (var event in painEvents) {
            if (isDefined(painEvents[event].date)) {
                var time = parser.momentJS(painEvents[event].date),
                    recordYear = time.year(),
                    recordMonth = time.month();
                var str = recordYear.toString();
                if (isDefined(painEvents[event].severity) && isDefined(painEvents[event].num)) {
                    painEvents[event].severity = painEvents[event].severity / painEvents[event].num;
                }
                str = str.concat('-', recordMonth);
                if (!allMonths[str]) {
                    allMonths[str] = {year: recordYear, month: recordMonth, events: []};
                }
                allMonths[str].events.push(painEvents[event]);
            }
        }
        return Object.keys(allMonths).map(function (key) {
            return allMonths[key];
        });
    };

    /*
     * Search section fields for each day and sort it by days and months
     */
    var getOverlaysFormRecord = function (record, overlaySettings) {
        var overlayNum = 0;
        var overlays = {
            overlay0: null,
            overlay1: null,
            overlay2: null,
            overlay3: null,
            overlay4: null,
            overlay5: null
        };
        if (!isDefined(overlaySettings) || !isDefined(overlaySettings.overlaySettings)) {
            return overlays;
        } else {
            overlaySettings = overlaySettings.overlaySettings;
        }
        forEach(overlaySettings, function (index, overlaySetting) {
            switch (index) {
                case 'pref_type':
                case undefined:
                    break;
                case 'alleviating_factor':
                    forEach(overlaySetting, function (i, overlayValue) {
                        if (isDefined(record.alleviating) && isDefined(record.alleviating.effective)) {
                            forEach(record.alleviating.effective, function (i, value) {
                                if (value.indexOf(overlayValue) >= 0) {
                                    var str = 'overlay';
                                    overlays[str.concat(overlayNum)] = true;
                                }
                            });
                        }
                        overlayNum++;
                    });
                    break;
                case 'ineffective_factor':
                    forEach(overlaySetting, function (i, overlayValue) {
                        if (isDefined(record.alleviating) && isDefined(record.alleviating.ineffective)) {
                            forEach(record.alleviating.ineffective, function (i, value) {
                                if (value.indexOf(overlayValue) >= 0) {
                                    var str = 'overlay';
                                    overlays[str.concat(overlayNum)] = true;
                                }
                            });
                        }
                        overlayNum++;
                    });
                    break;
                case 'aggravating_factor':
                    forEach(overlaySetting, function (i, overlayValue) {
                        if (isDefined(record.aggravating)) {
                            forEach(record.aggravating, function (i, value) {
                                if (value.indexOf(overlayValue) >= 0) {
                                    var str = 'overlay';
                                    overlays[str.concat(overlayNum)] = true;
                                }
                            });
                        }
                        overlayNum++;
                    });
                    break;
                default:
                    forEach(overlaySetting, function (i, overlayValue) {
                        if (isDefined(record[index])) {
                            forEach(record[index], function (i, value) {
                                if (value === overlayValue) {
                                    var str = 'overlay';
                                    overlays[str.concat(overlayNum)] = true;
                                }
                            });
                        }
                        overlayNum++;
                    });
                    break;
            }
        });
        return overlays;
    };

    /*
        Calculating severity / number of records / change values for all records containing specific section item (for each section)
     */
    var getSectionsFrequenciesChartsData = function (painRecords, dailyReflections, prevPainRecords, prevDailyReflections, insightsSections, calculateBy) {

        // Fill in records info for each section item
        fillSectionItemInformation(painRecords, insightsSections);
        fillSectionItemInformation(dailyReflections, insightsSections);
        fillSectionItemInformation(prevPainRecords, insightsSections, true);
        fillSectionItemInformation(prevDailyReflections, insightsSections, true);

        forEach(insightsSections, function (i, section) {
            if (section.id !== 'pain_type' && section.id !== 'pain_duration' &&
                section.items && section.items.length > 0) {
                getAverageSeverityForRecordsContainingItem(section.items, calculateBy);
                getAverageSeverityForRecordsContainingItem(section.items, calculateBy, true);
            }
        });

        forEach(insightsSections, function (i, section) {
            if (section.id !== 'pain_type' && section.id !== 'pain_duration' &&
                section.items && section.items.length > 0) {
                forEach(section.items, function (j, item) {
                    fillChangeData(item.bar_chart_data);
                });
            }
        });
    };

    /*
        Removing unused sections properties - e.g arrays with records / users info, etc.
     */
    var cleanUpSectionsInfo = function (sections) {
        forEach(sections, function (i, section) {
            if (section.id !== 'pain_type' && section.id !== 'pain_duration' &&
                section.items && section.items.length > 0) {
                forEach(section.items, function (j, item) {
                    if (item.bar_chart_data) {
                        delete item.bar_chart_data.user_ids;
                        delete item.bar_chart_data.prev_user_ids;
                        delete item.bar_chart_data.records_info;
                        delete item.bar_chart_data.prev_records_info;
                        delete item.bar_chart_data.records_per_user_info;
                        delete item.bar_chart_data.prev_records_per_user_info;
                    }
                });
            }
        })
    };

    /*
        Initializing translation strings
     */
    parser.translations = default_translations;
    parser.initTranslations = function (translations) {
        if (isDefined(translations) && !isEmpty(translations)) {
            parser.translations = translations;
        }
    };

    /*
        Initializing dependencies - moment js and thenBy libraries
     */
    parser.initDependencies = function (momentJS, thenByJS) {
        parser.momentJS = momentJS;
        parser.thenByJS = thenByJS;
    };

    /*
        Data processing: parsing records factors, timing/offset,
        determining records (pain records and daily reflections) that belong to the current and compare to periods
     */

    var processRecords = function (allRecords, participants, participantStatus, daterangeObject, followUpListMode, returnAllRecords) {
        var painRecords = [];
        var dailyReflectionRecords = [];
        var parsedAllRecords = [];

        forEach(allRecords, function (i, record) {

            // ignore record if it's already deleted, or if its severity is null
            if (record.deleted !== 1 && !isNaN(record.severity) && record.severity >= 0) {

                record.severity = parseInt(record.severity);
                record.expanded = false;
                record.hovered = false;
                record.final_timing = getFinalTiming(record);
                fillFormattedDates(record);
                record.date = record.recordsDateFormat;
                if (daterangeObject.tz) {
                    var offset = new parser.momentJS.tz.zone(daterangeObject.tz).utcOffset(
                        (parseInt(record.timing) + parseInt(record.time_offset))) * 60000;
                    record.final_timing = parseInt(record.timing) + parseInt(record.time_offset) + offset;
                    var dateTmst = new Date(parseInt(record.timing) + parseInt(record.time_offset) + offset);
                    record.date = parser.momentJS(dateTmst).format(recordsDateFormat);
                }
                record.days_ago = Math.round((new Date() - record.final_timing) / 1000 / 60 / 60 / 24);
                record.hours_ago = Math.round((new Date() - record.final_timing) / 1000 / 60 / 60);
                if (Math.abs(record.hours_ago) < 24) {
                    record.days_ago = 0;
                }

                if (record.pain_record_type === 'PainRecord') {

                    /*
                        parsing factors first
                     */
                    record = parseAlleviatingFactor(record);
                    record = parseAggravatingFactor(record);

                    if (record.pain_duration) {
                        var duration = parseInt(record.pain_duration);
                        if ((record.token_type && record.token_type === 'android') ||
                            (record.token_type && record.token_type === 'ios') ||
                            !record.token_type) {
                            var tmpDuration = parseInt(record.pain_duration);
                            record.pain_duration_unit = (record.pain_duration_unit) ? record.pain_duration_unit : 'Minutes';
                            if (record.pain_duration_unit === 'Hours') {
                                tmpDuration = Math.round(tmpDuration / 3600) === 0 ? roundWithPrecision(tmpDuration / 3600, 1) : Math.round(tmpDuration / 3600);
                            } else if (record.pain_duration_unit === 'Minutes') {
                                tmpDuration = Math.round(tmpDuration / 60) === 0 ? roundWithPrecision(tmpDuration / 60, 1) : Math.round(tmpDuration / 60);
                            }
                            resultedDuration = tmpDuration + translate(record.pain_duration_unit.toLowerCase());
                        } else if (record.token_type && record.token_type !== 'android') {
                            var parsedDuration = secondsToDHMS(duration);
                            var resultedDuration = '';
                            var usedUnitsCount = 0;
                            forEach(parsedDuration, function (key, item) {
                                if (item && usedUnitsCount < 3) {
                                    resultedDuration += item + translate(key) + ' ';
                                    usedUnitsCount++;
                                }

                            });
                            resultedDuration = resultedDuration.slice(0, -1);
                        }

                        var allDayThreshold = 86400;
                        var startTime = parser.momentJS(record.final_timing).format('HH:mm:ss');
                        if (daterangeObject.tz) {
                            startTime = parser.momentJS(record.timing  + record.time_offset).format('HH:mm:ss');
                        }
                        if (duration === allDayThreshold && startTime === '00:00:00') {
                            record.pain_duration_name = translate('all_day');
                            record.pain_duration_desktop_name = translate('all_day');
                        } else if (duration > 0) {
                            record.pain_duration_name = translate('full_pain_duration', 'replace', resultedDuration);
                            record.pain_duration_desktop_name = resultedDuration;
                        }
                    }
                    var sectionsToShow = 0;
                    var sectionsExists = 0;
                    forEach(recordSections, function (i, section) {
                        if (record[section] && record[section].length > 0) {
                            if (sectionsToShow < 3) {
                                record[section].show = true;
                                sectionsToShow++;
                            }
                            sectionsExists++;
                        }
                    });
                    if (sectionsExists > sectionsToShow) {
                        record.show_more = true;
                    }
                    painRecords.push(record);
                    if (returnAllRecords) {
                        parsedAllRecords.push(record);
                    }
                } else if (record.pain_record_type === 'DailyReflection') {
                    dailyReflectionRecords.push(record);
                    if (returnAllRecords) {
                        parsedAllRecords.push(record);
                    }
                }
            }
        });

        var currentParticipants = [];
        if (participantStatus) {

            if (participantStatus !== 'all') {
                forEach(participants, function (i, participant) {
                    if (participant.status === participantStatus) {
                        currentParticipants.push(participant);
                    }
                });
            } else {
                currentParticipants = participants;
            }

            var tmpSelected = [];
            forEach(currentParticipants, function (i, participant) {
                if (participant.isSelected == true) {
                    tmpSelected.push(participant);
                }
            });
            // if no participants with isSelected: true - then include ALL currentParticipants into selection
            if (tmpSelected.length > 0) {
                currentParticipants = tmpSelected;
            }

            if (followUpListMode) {
                var tmpFollowed = [];
                forEach(tmpSelected, function (i, participant) {
                    if (participant.isFollowed == true) {
                        tmpFollowed.push(participant);
                    }
                });
                currentParticipants = tmpFollowed;
            }

        } else {
            currentParticipants = participants;
        }

        var tmpPainRecords = [];
        var tmpDailyReflections = [];
        forEach(currentParticipants, function (i, participant) {
            var startDate = parser.momentJS(daterangeObject.start_date).valueOf();
            var endDate = parser.momentJS(daterangeObject.end_date).valueOf() + 24 * 60 * 60 * 1000 - 1;
            if (daterangeObject.tz) {
                startDate = startDate + new parser.momentJS.tz.zone(daterangeObject.tz).utcOffset(startDate) * 60000;
                endDate = endDate + new parser.momentJS.tz.zone(daterangeObject.tz).utcOffset(endDate) * 60000;
            }
            forEach(painRecords, function (i, record) {
                if (record.patient_id === participant.uid
                    && record.final_timing >= startDate && record.final_timing <= endDate) {
                    tmpPainRecords.push(record);
                }
            });
            forEach(dailyReflectionRecords, function (i, record) {
                if (record.patient_id === participant.uid
                    && record.final_timing >= startDate && record.final_timing <= endDate) {
                    tmpDailyReflections.push(record);
                }
            });
        });
        var finalDailyReflectionRecords = tmpDailyReflections;
        var finalPainRecords = tmpPainRecords;
        setAverageSeverityPerDate(finalDailyReflectionRecords, finalPainRecords, daterangeObject);

        /*
         Determining records that belong to the previous (compare to) period
         */

        var prevPainRecords = [];
        var prevDailyReflections = [];

        var participantIds = [];
        forEach(currentParticipants, function (i, participant) {
            participantIds.push(participant.uid);
        });

        forEach(allRecords, function (i, record) {
            if (inArray(record.patient_id, participantIds)) {
                if (isRecordInPrevDateRange(record, daterangeObject)) {
                    if (record.pain_record_type === "PainRecord") {
                        prevPainRecords.push(record);
                    } else if (record.pain_record_type === "DailyReflection") {
                        prevDailyReflections.push(record);
                    }
                }
            }
        });

        return {
            painRecords: finalPainRecords,
            dailyReflections: finalDailyReflectionRecords,
            prevPainRecords: prevPainRecords,
            prevDailyReflections: prevDailyReflections,
            participants: participants,
            parsedAllRecords: parsedAllRecords
        };
    };

    /*
        Getting all data needed for charts, bars, etc. from the processed records
     */
    var calculateAllInsightsData = function (painRecords, dailyReflections, prevPainRecords,
                                             prevDailyReflections, participantsSet, insightsSections,
                                             calculateBy, daterangeObject, followUpListMode, overlaySettings, calendarRecords, calendarDateRange) {

        var participants = [];
        var numOfSelected = getNumberOfSelected(participantsSet, followUpListMode);
        if (numOfSelected > 0 && numOfSelected !== participantsSet.length) {
            forEach(participantsSet, function (i, participant) {
                if (participant.isSelected) {
                    participants.push(participant);
                }
            })
        } else {
            participants = participantsSet;
        }

        var filteredRecords = {};
        var prevFilteredRecords = {};
        var filteredAllRecords = {};
        // Loop on insights sections and initialize the numerator and denominator
        forEach(insightsSections, function (i, section) {
            section.representative_bar = {
                numerator: (calculateBy === "records") ? 0 : [],
                denominator: 0,
                prev_numerator: (calculateBy === "records") ? 0 : [], // Getting prev numerator
                prev_denominator: 0,  // Getting prev denominator
                users: [] // Number of users with records containing certain section
            };

            section.items = {};
            section.show_more = false;
        });

        forEach(participants, function (i, participant) {
            var userId = participant.uid;
            // Current filtered records
            filteredRecords[userId] = {
                "PainRecord": {
                    "records": []
                },
                "DailyReflection": {
                    "records": []
                }
            };
            // Previous filtered records
            prevFilteredRecords[userId] = {
                "PainRecord": {
                    "records": []
                },
                "DailyReflection": {
                    "records": []
                }
            };
            filteredAllRecords[userId] = {
                "PainRecord": {
                    "records": []
                },
                "DailyReflection": {
                    "records": []
                }
            };

            forEach(calendarRecords, function (i, record) {
                if (record.patient_id === userId) {
                    filteredAllRecords[userId][record.pain_record_type].records.push(record);
                }
            });
            forEach(painRecords, function (i, record) {
                if (record.patient_id === userId) {
                    if (isRecordInDateRange(record, daterangeObject)) {
                        filteredRecords[userId][record.pain_record_type].records.push(record);
                    }
                }
            });

            forEach(dailyReflections, function (i, record) {
                if (record.patient_id === userId) {
                    if (isRecordInDateRange(record, daterangeObject)) {
                        filteredRecords[userId][record.pain_record_type].records.push(record);
                    }
                }
            });

            forEach(prevPainRecords, function (i, record) {
                if (record.patient_id === userId) {
                    if (isRecordInPrevDateRange(record, daterangeObject)) {
                        prevFilteredRecords[userId][record.pain_record_type].records.push(record);
                    }
                }
            });

            forEach(prevDailyReflections, function (i, record) {
                if (record.patient_id === userId) {
                    if (isRecordInPrevDateRange(record, daterangeObject)) {
                        prevFilteredRecords[userId][record.pain_record_type].records.push(record);
                    }
                }
            });
        });

        var painRecordsArray = [],
            prevPainRecordsArray = [];
        var dailyReflectionsArray = [],
            prevDailyReflectionsArray = [];

        var numUsersMatchingPainRecord = 0,
            prevNumUsersMatchingPainRecord = 0;
        var numUsersMatchingDailyReflection = 0,
            prevNumUsersMatchingDailyReflection = 0;

        var painTypes = {};
        // All three pain types mentioned here
        painTypes.Constant = painTypes.Intermittent = painTypes.Breakthrough = 0;
        // Arrays needed for calculating PainType values when calculateBy == 'participants'
        var constantTypeUniqueUsers = [], intermittentTypeUniqueUsers = [], breakthroughTypeUniqueUsers = [];

        // Pain duration
        var painDurations = {};
        painDurations.less_hour = painDurations.less_three = painDurations.less_six = painDurations.less_twelve = painDurations.less_twenty_four = painDurations.twenty_four = painDurations.more_twenty_four = 0;
        // Arrays needed for calculating painDurations values when calculateBy == 'participants'
        var lessHourDurationUniqueUsers = [], lessThreeDurationUniqueUsers = [],
            lessSixDurationUniqueUsers = [], lessTwelveDurationUniqueUsers = [],
            lessTwentyFourDurationUniqueUsers = [], twentyFourDurationUniqueUsers = [],
            moreTwentyFourDurationUniqueUsers = [];

        forEach(filteredRecords, function (userId, fRecord) {
            painRecordsArray = painRecordsArray.concat(fRecord.PainRecord.records);
            dailyReflectionsArray = dailyReflectionsArray.concat(fRecord.DailyReflection.records);
            if (fRecord.PainRecord.records.length > 0) {
                numUsersMatchingPainRecord++; // Getting user count who have pain records
            }
            if (fRecord.DailyReflection.records.length > 0) {
                numUsersMatchingDailyReflection++; // Getting user count who have daily reflection records
            }

            // Looping on pain records
            forEach(fRecord.PainRecord.records, function (i, record) {
                // Looping on insights section
                forEach(insightsSections, function (i, section) {
                    if (section.id === "pain_duration") { // If section is pain duration
                        if (record.pain_duration > 0) {
                            if (calculateBy === "records") {
                                section.representative_bar.numerator++;
                                fillDuration(record.pain_duration, record.pain_duration_unit, painDurations);
                            } else {
                                if (!inArray(userId, section.representative_bar.numerator)) {
                                    section.representative_bar.numerator.push(userId);
                                }
                                var duration = parseDuration(record.pain_duration);
                                if (duration === 'less_hour' && !inArray(userId, lessHourDurationUniqueUsers)) {
                                    lessHourDurationUniqueUsers.push(userId);
                                    painDurations.less_hour += 1;
                                } else if (duration === 'less_three' && !inArray(userId, lessThreeDurationUniqueUsers)) {
                                    lessThreeDurationUniqueUsers.push(userId);
                                    painDurations.less_three += 1;
                                } else if (duration === 'less_six' && !inArray(userId, lessSixDurationUniqueUsers)) {
                                    lessSixDurationUniqueUsers.push(userId);
                                    painDurations.less_six += 1;
                                } else if (duration === 'less_twelve' && !inArray(userId, lessTwelveDurationUniqueUsers)) {
                                    lessTwelveDurationUniqueUsers.push(userId);
                                    painDurations.less_twelve += 1;
                                } else if (duration === 'less_twenty_four' && !inArray(userId, lessTwentyFourDurationUniqueUsers)) {
                                    lessTwentyFourDurationUniqueUsers.push(userId);
                                    painDurations.less_twenty_four += 1;
                                } else if (duration === 'twenty_four' && !inArray(userId, twentyFourDurationUniqueUsers)) {
                                    twentyFourDurationUniqueUsers.push(userId);
                                    painDurations.twenty_four += 1;
                                } else if (duration === 'more_twenty_four' && !inArray(userId, moreTwentyFourDurationUniqueUsers)) {
                                    moreTwentyFourDurationUniqueUsers.push(userId);
                                    painDurations.more_twenty_four += 1;
                                }
                            }
                            fillTypeOrDurationItems(record, section, false);
                        }
                    } else if (section.id === "pain_type") { // If section is pain type
                        if (record.pain_type) {
                            if (calculateBy === "records") {
                                if (record.pain_type === "Constant") {
                                    painTypes.Constant += 1;
                                } else if (record.pain_type === "Intermittent") {
                                    painTypes.Intermittent += 1;
                                } else if (record.pain_type === "Breakthrough") {
                                    painTypes.Breakthrough += 1;
                                }
                                section.representative_bar.numerator++;
                            } else {
                                if (!inArray(userId, section.representative_bar.numerator)) {
                                    section.representative_bar.numerator.push(userId);
                                }
                                if (record.pain_type === "Constant" && !inArray(userId, constantTypeUniqueUsers)) {
                                    constantTypeUniqueUsers.push(userId);
                                    painTypes.Constant += 1;
                                } else if (record.pain_type === "Intermittent" && !inArray(userId, intermittentTypeUniqueUsers)) {
                                    intermittentTypeUniqueUsers.push(userId);
                                    painTypes.Intermittent += 1;
                                } else if (record.pain_type === "Breakthrough" && !inArray(userId, breakthroughTypeUniqueUsers)) {
                                    breakthroughTypeUniqueUsers.push(userId);
                                    painTypes.Breakthrough += 1;
                                }
                            }
                            fillTypeOrDurationItems(record, section, false);
                        }
                    } else if (section.id !== "meaningful_activities" && !isEmpty(record[section.id])) { // If section is not meaningful activities
                        if (calculateBy === "records") {
                            section.representative_bar.numerator++;
                            if (!inArray(userId, section.representative_bar.users)) {
                                section.representative_bar.users.push(userId);
                            }
                        } else {
                            if (!inArray(userId, section.representative_bar.numerator)) {
                                section.representative_bar.numerator.push(userId);
                            }
                        }
                        fillSectionItems(record, section, false);
                    }
                });
            });
            // Looping on daily reflection records
            forEach(fRecord.DailyReflection.records, function (i, record) {
                // Looping on insights section
                forEach(insightsSections, function (i, section) {
                    if (section.id === "meaningful_activities" && !isEmpty(record[section.id])) { // If section is not meaningful activities
                        if (calculateBy === "records") {
                            section.representative_bar.numerator++;
                            if (!inArray(userId, section.representative_bar.users)) {
                                section.representative_bar.users.push(userId);
                            }
                        } else {
                            if (!inArray(userId, section.representative_bar.numerator)) {
                                section.representative_bar.numerator.push(userId);
                            }
                        }
                        fillSectionItems(record, section, false);
                    }
                });
            });
        });

        // Looping on previous records to calculate the change value
        forEach(prevFilteredRecords, function (userId, fRecord) {
            prevPainRecordsArray = prevPainRecordsArray.concat(fRecord.PainRecord.records);
            prevDailyReflectionsArray = prevDailyReflectionsArray.concat(fRecord.DailyReflection.records);
            if (fRecord.PainRecord.records.length > 0) {
                prevNumUsersMatchingPainRecord++;
            }
            if (fRecord.DailyReflection.records.length > 0) {
                prevNumUsersMatchingDailyReflection++;
            }

            // Looping on pain records
            forEach(fRecord.PainRecord.records, function (i, record) {
                // Looping on insights section
                forEach(insightsSections, function (i, section) {
                    if (section.id !== "meaningful_activities" && !isEmpty(record[section.id])) {
                        if (calculateBy === "records") {
                            section.representative_bar.prev_numerator++;
                        } else {
                            if (!inArray(userId, section.representative_bar.prev_numerator)) {
                                section.representative_bar.prev_numerator.push(userId);
                            }
                        }
                        // Call function to fill values against each section items
                        if (section.id === 'pain_type' || section.id === 'pain_duration') {
                            fillTypeOrDurationItems(record, section, true);
                        } else {
                            fillSectionItems(record, section, true);
                        }
                    }
                });
            });
            // Looping on daily reflection records
            forEach(fRecord.DailyReflection.records, function (i, record) {
                forEach(insightsSections, function (i, section) {
                    if (section.id === "meaningful_activities" && !isEmpty(record[section.id])) {
                        if (calculateBy === "records") {
                            section.representative_bar.prev_numerator++;
                        } else {
                            if (!inArray(userId, section.representative_bar.prev_numerator)) {
                                section.representative_bar.prev_numerator.push(userId);
                            }
                        }
                        // Call function to fill values against each section items
                        fillSectionItems(record, section, true);
                    }
                });
            });
        });

        // Looping on insights section
        forEach(insightsSections, function (i, section) {
            // If calculated by records
            if (calculateBy === "records") {
                section.representative_bar.denominator = (section.id !== "meaningful_activities") ? painRecordsArray.length : dailyReflectionsArray.length;
                // For prev
                section.representative_bar.prev_denominator = (section.id !== "meaningful_activities") ? prevPainRecordsArray.length : prevDailyReflectionsArray.length;
            } else { // If calculated by users
                section.representative_bar.numerator = section.representative_bar.numerator.length;
                section.representative_bar.denominator = (section.id !== "meaningful_activities") ? numUsersMatchingPainRecord : numUsersMatchingDailyReflection;
                // For prev
                section.representative_bar.prev_numerator = section.representative_bar.prev_numerator.length;
                section.representative_bar.prev_denominator = (section.id !== "meaningful_activities") ? prevNumUsersMatchingPainRecord : prevNumUsersMatchingDailyReflection;
            }
        });

        var dashboard_new = translate('dashboard_new');
        // Looping on insights section for calculating percentage change
        forEach(insightsSections, function (i, section) {
            section.representative_bar.percent = Math.round(section.representative_bar.numerator / section.representative_bar.denominator * 100);
            section.items = object2Array(section.items); // Type casting object to array
            var curRecords, prevRecords; // Copy records arrays to the loop local variables depending on the section
            if (section.id !== "meaningful_activities") {
                curRecords = painRecordsArray;
                prevRecords = prevPainRecordsArray;
            } else {
                curRecords = dailyReflectionsArray;
                prevRecords = prevDailyReflectionsArray;
            }

            forEach(section.items, function (i, item) {
                item.denominator = section.representative_bar.numerator;
                item.numerator = (calculateBy === "records") ? 0 : [];

                item.prev_denominator = section.representative_bar.prev_numerator;
                item.prev_numerator = (calculateBy === "records") ? 0 : [];
            });
            forEach(curRecords, function (e, record) {
                if (isEmpty(record[section.id])) {
                    return true;
                }

                forEach(record[section.id], function (i, v) {
                    var tmp = v;
                    forEach(section.items, function (i, item) {
                        if (item.name_encoded === tmp) {
                            if (calculateBy === "records") {
                                item.numerator++;
                            } else {
                                if (!inArray(record.patient_id, item.numerator)) {
                                    item.numerator.push(record.patient_id);
                                }
                            }
                        }
                    });
                });
            });
            forEach(prevRecords, function (e, record) {
                if (isEmpty(record[section.id])) {
                    return true;
                }

                forEach(record[section.id], function (i, v) {
                    var tmp = v;
                    forEach(section.items, function (i, item) {
                        if (item.name_encoded === tmp) {
                            if (calculateBy === "records") {
                                item.prev_numerator++;
                            } else {
                                if (!inArray(record.patient_id, item.prev_numerator)) {
                                    item.prev_numerator.push(record.patient_id);
                                }
                            }
                        }
                    });
                });
            });

            // Looping on items for getting change value
            forEach(section.items, function (i, item) {
                if (calculateBy === "participants") { // If by participants
                    item.numerator = item.numerator.length;
                    item.prev_numerator = item.prev_numerator.length;
                }
                item.percent = Math.round(item.numerator / item.denominator * 100);
                item.prev_percent = 0;
                if (item.prev_denominator !== 0 && item.prev_numerator !== 0) {
                    var prev_percent = Math.round(item.prev_numerator / item.prev_denominator * 100);
                    if (prev_percent !== 0) {
                        item.prev_percent = Math.round((item.percent - prev_percent));
                    }
                } else if (item.prev_numerator === 0) {
                    item.prev_percent = dashboard_new; // If prev period has no record then show NEW
                }
            });
            /*
                Sorting items array with thenBy.js library:
                first by percent with desc order, then by name with asc alphabetical order
            */
            section.items.sort(
                parser.thenByJS("percent", -1)
                    .thenBy("name", {ignoreCase: true})
            );
            section.remaining_items = isDefined(section.max_values_to_show) ? section.items.length - section.max_values_to_show : 0;
        });


        getSectionsFrequenciesChartsData(painRecords, dailyReflections, prevPainRecords, prevDailyReflections, insightsSections, calculateBy);

        cleanUpSectionsInfo(insightsSections); // remove unused sections properties

        var totals = getSeverityAndFunctionChartsData(filteredRecords, prevFilteredRecords, calculateBy, daterangeObject, overlaySettings, filteredAllRecords, calendarDateRange);

        var allPainSum = painTypes.Breakthrough + painTypes.Intermittent + painTypes.Constant;
        var allDurationSum = painDurations.less_hour + painDurations.less_three + painDurations.less_six + painDurations.less_twelve + painDurations.less_twenty_four + painDurations.twenty_four + painDurations.more_twenty_four;

        var result = {
            allPainSum: allPainSum,
            allDurationSum: allDurationSum,
            painDurations: painDurations,
            painTypes: painTypes,
            sections: insightsSections
        };
        result = Object.assign(result, totals);

        return result;
    };

    /***************************************
     Main function
     Needs to be called by each platform

     If omitCalculations is true - then only filtered records for the current date range will be returned
     ***************************************/
    parser.parseAllRecords = function (allRecords, participants, participantStatus, daterangeObject,
                                       followUpListMode, insightsSections, calculateBy, overlaySettings, calendarDateRange, omitCalculations) {

        // Check if necessary dependencies are initialized
        if (!isDefined(parser.momentJS) || !isDefined(parser.thenByJS)) {
            throw ('Data-parser: Necessary dependencies are not initialized');
        }

        // Check that necessary data sets are provided - records, participants and sections
        if (!isDefined(allRecords) ||
            !isDefined(participants) ||
            !isDaterangeObjectValid(daterangeObject) ||
            !["records", "participants"].includes(calculateBy)) {
            throw ('Data-parser: Provided parameters are incorrect');
        }

        var processedResult = processRecords(allRecords, participants, participantStatus, daterangeObject, followUpListMode, !!calendarDateRange);
        if (processedResult && !omitCalculations) {

            if (!isDefined(insightsSections) || isEmpty(insightsSections)) {
                throw ('Data-parser: Provided parameters are incorrect');
            }

            var painRecords = processedResult.painRecords,
                dailyReflections = processedResult.dailyReflections,
                prevPainRecords = processedResult.prevPainRecords,
                prevDailyReflections = processedResult.prevDailyReflections,
                processedParticipants = processedResult.participants,
                parsedAllRecords = processedResult.parsedAllRecords;
            var finalResult = calculateAllInsightsData(painRecords, dailyReflections, prevPainRecords,
                prevDailyReflections, processedParticipants, insightsSections,
                calculateBy, daterangeObject, followUpListMode, overlaySettings, parsedAllRecords, calendarDateRange);

            finalResult = Object.assign(finalResult, processedResult);
            return finalResult;
        } else if (processedResult) {
            return {
                painRecords: processedResult.painRecords,
                dailyReflections: processedResult.dailyReflections
            };
        }
    };

    /*
        Global define of parser
     */
    if (typeof define === "function" && define.amd) this.parser = parser, define(parser); else if (typeof module === "object" && module.exports) module.exports = parser; else this.parser = parser;
})();
